import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import {
  selectOAuthOpenedFromButton,
  setIsAuthenticationOpen,
} from "lib/redux/uiSlice";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import Image from "next/image";
import { setRedirectTo } from "lib/redux/redirect";

interface AuthenticationProps {
  redirectTo?: string;
}

export const AuthenticationOptions: React.FC<AuthenticationProps> = ({redirectTo}) => {
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  dispatch(setRedirectTo(redirectTo ? redirectTo : pathname));
  const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
  const OAUTH2_REDIRECT_URI = process.env.NEXT_PUBLIC_OAUTH2_REDIRECT_URI;
  const GOOGLE_AUTH_URL = `${API_BASE_URL}/oauth2/authorize/google?redirect_uri=${OAUTH2_REDIRECT_URI}`;

  // Close the modal when clicking outside the popup
  const handleClickOutside = (event: MouseEvent) => {
    const modal = document.getElementById("auth-modal");
    if (modal && !modal.contains(event.target as Node)) {
      dispatch(setIsAuthenticationOpen(false));
    }
  };
  useEffect(() => {
    localStorage.setItem("current-page", redirectTo ? redirectTo : pathname);
  }, [pathname]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div
        id="auth-modal"
        className="relative flex h-44 w-[270px] items-center justify-center rounded-3xl bg-white shadow-lg md:w-80 lg:w-96"
      >
        <button
          className="absolute -right-3 -top-6 flex h-5 w-5 items-center justify-center rounded-full bg-white text-xl"
          onClick={() => dispatch(setIsAuthenticationOpen(false))}
        >
          &times;
        </button>

        <div>
          <button
            onClick={() => {
              dispatch(setIsAuthenticationOpen(false));
              window.location.href = GOOGLE_AUTH_URL || "#";
            }}
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.168) 0px 2px 3px, rgba(0, 0, 0, 0.168) 0px 2px 3px",
            }}
            className="flex w-[100%] items-center gap-2 whitespace-nowrap rounded-[48px] px-10 py-4 text-xs md:text-sm lg:text-base"
          >
            <Image
              src="/assets/googleAuthIcon.png"
              alt="Google Logo"
              width={20}
              height={20}
            />
            Sign In with Google
          </button>
          {/* <button
            onClick={() =>
              (window.location.href =
                process.env.NEXT_PUBLIC_GITHUB_AUTH_URL || "#")
            }
            className="w-full rounded bg-gray-800 p-2 text-white hover:bg-gray-700"
          >
            Sign In with GitHub
          </button> */}
        </div>
      </div>
    </section>
  );
};
